var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('ul',_vm._l((_vm.links),function(link){return _c('li',{class:[_vm.$route.name === link.name ? 'active' : '']},[_c('router-link',{attrs:{"to":{ path: link.path }}},[_vm._v(_vm._s(link.text))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }